import * as React from 'react';

const HeaderBanner = () => (
  <div
    id="hb"
    style={{
      alignSelf: 'center',
      maxHeight: '250px',
      maxWidth: '100%',
      textAlign: 'center',
    }}>
    <div data-fuse="22969287382" style={{ maxHeight: '250px' }}></div>
  </div>
);
export default HeaderBanner;
